import authRules from '../authRules.js';

const approvals = (user) => {
  const { approvals } = user.securityLevels;

  if (approvals >= authRules.approvals.approvals) {
      return true;
  } else {
      return false;
    }
  }


export default approvals;
